import MRForm from 'components/form/MRForm/container';

export default MRForm;
